import { z } from 'zod';

const createTimeRegExp = /(\d+)/gi;

export const stringifiedDateSchema = z.union([z.string(), z.date(), z.number()]).transform((val) => {
  if (val instanceof Date) {
    return val.valueOf();
  }
  if (typeof val === 'number') {
    if (val.toString().length >= 13) return val;
    return val * 1000;
  }
  if (val.includes('Date')) {
    return new Date(Number.parseInt((val as string).match(createTimeRegExp)?.[0] ?? '0', 10)).valueOf();
  }

  const parsed = Date.parse(val);
  return Number.isNaN(parsed) ? Date.now() : parsed;
});

export const avatarUrlSchema = z
  .union([z.string().trim(), z.string().url()])
  .nullish()
  .transform((val) => (val === null || val === undefined ? '' : val))
  .catch('');

export const nameSchema = z
  .string()
  .trim()
  .nullish()
  .transform((val) => (val === null || val === undefined ? '' : val))
  .catch('');

export const nicknameSchema = z
  .string()
  .trim()
  .min(1, 'errors.string.length|count=1')
  .max(15, 'errors.string.max-length|count=15');
